import React from 'react';
import { useTemplatesContext } from '../Templates/TemplatesContext';
export const Template = _ref => {
  let {
    name,
    children
  } = _ref;
  const {
    activePage
  } = useTemplatesContext();
  if ((activePage == null ? void 0 : activePage.templateName) === name) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return null;
};
//# sourceMappingURL=Template.js.map